module.exports = __webpack_public_path__ + "static/media/test-image-4.026c8581.png";